<template>
    <div class="is-grow-1 mt-4">
        <!-- MAPA -->
        <div class="mapa-wrapper pt-2" v-show="!$root.gmapsFailure">
            <gmap-map
                ref="mapRef"
                class="gmaps"
                :center="center"
                :zoom="zoomLevel"
                :options="mapOptions"
            >
                <!-- Info Window: Balão de informações quando clica no pin -->
                <gmap-info-window
                    ref="infoWindow"
                    :position="infoWindow.position"
                    :opened="infoWindow.open"
                    :options="infoWindow.options"
                    @closeclick="closeInfoWindow"
                >
                    <!-- v-if: Garantir que as informações estejam dentro do infoWindow.item antes de abrir ele -->
                    <div class="info-window" v-if="infoWindow.open">
                        <!-- Informações do Cliente -->
                        <p class="info-window-nome">{{ infoWindow.item.cliente.rsocial }}</p>
                        <div class="info-detail">
                            <span class="has-text-weight-bold">{{ $t('nome') }}:</span>
                            <span class="has-text-right">{{ infoWindow.item.cliente.nome }}</span>
                        </div>
                        <div class="info-detail">
                            <span class="has-text-weight-bold">{{ $t('colaborador') }}:</span>
                            <span class="has-text-right">{{ infoWindow.item.usuario.nome }}</span>
                        </div>
                        <div class="info-detail">
                            <span class="has-text-weight-bold">{{ $t('status') }}:</span>
                            <span v-if="infoWindow.item.clienteAvulso">
                                {{ $t('avulso') }}
                            </span>
                            <span
                                v-else-if="
                                    (infoWindow.item.pedidos &&
                                        infoWindow.item.pedidos.length > 0) ||
                                    (infoWindow.item.naovendas &&
                                        infoWindow.item.naovendas.length > 0) ||
                                    (infoWindow.item.tomadaspreco &&
                                        infoWindow.item.tomadaspreco.length > 0) ||
                                    (infoWindow.item.atendimentos &&
                                        infoWindow.item.atendimentos.length > 0)
                                "
                            >
                                {{ $t('atendido') }}
                            </span>
                            <span v-else>
                                {{ $t('nao-atendido') }}
                            </span>
                        </div>
                        <hr class="my-2 mx-0" />

                        <!-- Informações da Rota -->
                        <div class="info-detail">
                            <span class="has-text-weight-bold">{{ $t('rota') }}:</span>
                            <span class="has-text-right">{{
                                infoWindow.item.rotaVisita.descricao
                            }}</span>
                        </div>
                        <div class="info-detail">
                            <span class="has-text-weight-bold">{{ $t('data-inicio') }}:</span>
                            <span class="has-text-right">{{
                                infoWindow.item.rotaVisita.datainicio | moment('L')
                            }}</span>
                        </div>
                        <div class="info-detail">
                            <span class="has-text-weight-bold">{{ $t('tipo-frequencia') }}:</span>
                            <span class="has-text-right">{{
                                $t(getTipoFrequencia(infoWindow.item.rotaVisita.tipoFrequencia))
                            }}</span>
                        </div>
                        <div
                            class="info-detail"
                            v-if="infoWindow.item.rotaVisita.tipoFrequencia == 1"
                        >
                            <span class="has-text-weight-bold">{{ $t('frequencia') }}:</span>
                            <span class="has-text-right">{{
                                $t('a-cada-n-dias', { n: infoWindow.item.rotaVisita.frequencia })
                            }}</span>
                        </div>
                        <div
                            class="info-detail"
                            v-if="infoWindow.item.rotaVisita.tipoFrequencia == 2"
                        >
                            <span class="has-text-weight-bold">{{ $t('frequencia') }}:</span>
                            <span class="has-text-right description">{{
                                /*  O que está acontecendo?
                                    A função getDias retorna um array de keys do dicionário pra dias da semana,
                                    ['segunda', 'terca', ...], o map passa eles pelo tradutor, o join separa eles por vírgula
                                    e o replace troca a última vírgula por "e" para fazer "Segunda, Terça e Quarta" */
                                getDias(infoWindow.item.rotaVisita.frequencia)
                                    .map((e) => $t(e))
                                    .join(', ')
                                    .replace(/, ([^,]*)$/, ` ${$t('+e')} $1`)
                            }}</span>
                        </div>
                        <div class="info-detail">
                            <span class="has-text-weight-bold">{{ $t('obriga-sequencia') }}</span>
                            <span class="has-text-right">{{
                                infoWindow.item.rotaVisita.obrigaSequencia ? $t('sim') : $t('nao')
                            }}</span>
                        </div>
                        <div class="info-detail">
                            <span class="has-text-weight-bold">{{ $t('permite-avulso') }}</span>
                            <span class="has-text-right">{{
                                $t(getPermiteAvulso(infoWindow.item.rotaVisita.permiteAvulso))
                            }}</span>
                        </div>
                        <div class="info-detail">
                            <span class="has-text-weight-bold">{{ $t('ordem') }}:</span>
                            <span class="has-text-right">{{
                                infoWindow.item.rotaCliente.ordem
                            }}</span>
                        </div>
                        <div class="info-detail">
                            <span class="has-text-weight-bold">{{ $t('periodo') }}:</span>
                            <span class="has-text-right">{{
                                $t(getPeriodo(infoWindow.item.rotaCliente.periodoDia))
                            }}</span>
                        </div>
                        <div class="info-detail">
                            <span class="has-text-weight-bold">{{ $t('observacao') }}:</span>
                            <span
                                class="has-text-right"
                                v-if="infoWindow.item.rotaCliente.observacao"
                                >{{ infoWindow.item.rotaCliente.observacao }}</span
                            >
                            <span class="has-text-right has-text-grey" v-else
                                >({{ $t('sem-observacao') }})</span
                            >
                        </div>

                        <hr
                            class="my-2 mx-0"
                            v-if="
                                (infoWindow.item.checks && infoWindow.item.checks.length > 0) ||
                                (infoWindow.item.pedidos && infoWindow.item.pedidos.length > 0) ||
                                (infoWindow.item.naovendas &&
                                    infoWindow.item.naovendas.length > 0) ||
                                (infoWindow.item.tomadaspreco &&
                                    infoWindow.item.tomadaspreco.length > 0) ||
                                (infoWindow.item.atendimentos &&
                                    infoWindow.item.atendimentos.length > 0)
                            "
                        />

                        <!-- Informações das ações executadas -->
                        <div
                            class="info-detail is-flex-wrap"
                            v-if="infoWindow.item.checks.length > 0"
                        >
                            <div class="is-100 is-flex is-flex-hbetween">
                                <span class="has-text-weight-bold">{{ $t('horarios') }}:</span>
                                <span class="has-text-right">{{
                                    infoWindow.item.checks.length
                                }}</span>
                            </div>
                            <table class="det-tbl">
                                <tbody>
                                    <tr v-for="c in infoWindow.item.checks" :key="c.uuid">
                                        <td>
                                            <div class="is-flex is-flex-centered">
                                                <span class="is-100 has-text-centered">{{
                                                    c.checkindatahora | moment('L LT')
                                                }}</span>
                                                <b-icon
                                                    size="is-small"
                                                    icon="chevron-right"
                                                    type="is-dark"
                                                />
                                                <span class="is-100 has-text-centered">{{
                                                    c.checkoutdatahora | moment('L LT')
                                                }}</span>
                                            </div>
                                        </td>
                                        <td class="has-text-right">
                                            <span class="is-100 has-text-right" v-if="c.duracao">
                                                {{ $moment.duration(c.duracao * 1000).humanize() }}
                                            </span>
                                            <span class="is-100 has-text-right" v-else> – </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div
                            class="info-detail is-flex-wrap"
                            v-if="infoWindow.item.pedidos.length > 0"
                        >
                            <div class="is-100 is-flex is-flex-hbetween">
                                <span class="has-text-weight-bold">{{ $t('pedidos') }}:</span>
                                <span class="has-text-right">{{
                                    infoWindow.item.pedidos.length
                                }}</span>
                            </div>
                            <table class="det-tbl">
                                <tbody>
                                    <tr v-for="p in infoWindow.item.pedidos" :key="p.idpedido">
                                        <td>{{ p.tipopedido }}</td>
                                        <td class="has-text-right">
                                            R$ {{ getDecimal(p.valortotal, p.scale) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="info-detail" v-if="infoWindow.item.naovendas.length > 0">
                            <span class="has-text-weight-bold">{{ $t('nao-vendas') }}:</span>
                            <span class="has-text-right">{{
                                infoWindow.item.naovendas.length
                            }}</span>
                        </div>
                        <div class="info-detail" v-if="infoWindow.item.tomadaspreco.length > 0">
                            <span class="has-text-weight-bold">{{ $t('tomadas-preco') }}:</span>
                            <span class="has-text-right">{{
                                infoWindow.item.tomadaspreco.length
                            }}</span>
                        </div>
                        <div class="info-detail" v-if="infoWindow.item.atendimentos.length > 0">
                            <span class="has-text-weight-bold">{{ $t('atendimentos') }}:</span>
                            <span class="has-text-right">{{
                                infoWindow.item.atendimentos.length
                            }}</span>
                        </div>
                    </div>
                </gmap-info-window>

                <!-- POLYLINE PLANEJADO -->
                <!-- As multiplicações por flags booleanas funcionam como se fosse valor numérico 1.
                     Feito isso pq não tem disponível a flag "visible" no polyline. -->
                <gmap-polyline
                    ref="polylinePlanejados"
                    v-for="k in Object.keys(polylines)"
                    :key="k"
                    :path="polylines[k].line"
                    :options="{
                        icons: [
                            {
                                icon: {
                                    path: 1,
                                    strokeColor: `#${
                                        polylines[k].color == '' || polylines[k].color == null
                                            ? '000'
                                            : polylines[k].color
                                    }`,
                                    strokeOpacity:
                                        0.3 *
                                        visibilityObject[polylines[k].idusuario] *
                                        showPlanned,
                                    scale: 2.8,
                                },
                                offset: '40%',
                                repeat: '50px',
                            },
                        ],
                        strokeColor: `#${
                            polylines[k].color == '' || polylines[k].color == null
                                ? '000'
                                : polylines[k].color
                        }`,
                        strokeOpacity: 0.3 * visibilityObject[polylines[k].idusuario] * showPlanned,
                    }"
                />

                <!-- POLYLINE EXECUTADO -->
                <gmap-polyline
                    ref="polylineExecutados"
                    v-for="k in Object.keys(polylineExecutado)"
                    :key="`${k}-e`"
                    :path="polylineExecutado[k].line"
                    :options="{
                        icons: [
                            {
                                icon: {
                                    path: 'M 0,-1 0,1',
                                    //strokeColor: `#${polylineExecutado[k].color}`,
                                    strokeColor: '#419545',
                                    strokeOpacity:
                                        1 *
                                        visibilityObject[polylineExecutado[k].idusuario] *
                                        showExecuted,
                                    scale: 4,
                                },
                                offset: '0',
                                repeat: '20px',
                            },
                            {
                                icon: {
                                    path: 1,
                                    strokeColor: '#419545',
                                    strokeOpacity:
                                        1 *
                                        visibilityObject[polylineExecutado[k].idusuario] *
                                        showExecuted,
                                    scale: 2.8,
                                },
                                offset: '40%',
                                repeat: '50px',
                            },
                        ],
                        strokeOpacity: 0,
                    }"
                />

                <!-- MARCADORES PLANEJADOS -->
                <gmap-marker
                    v-for="m in markers"
                    :key="m.id"
                    :position="m.location"
                    :icon="{
                        path: path,
                        fillColor: `#${m.color}`,
                        scale: 1,
                        fillOpacity: 1,
                        strokeWeight: 0,
                        anchor: { x: 10, y: 25 },
                        labelOrigin: { x: 10, y: 10 },
                    }"
                    :visible="visibilityObject[m.idusuario] && showPlanned"
                    @click="openInfoWindow(m)"
                />

                <!-- MARCADORES EXECUTADOS -->
                <div v-for="m in markersExecutado" :key="`${m.id}-e`">
                    <gmap-marker
                        v-if="m.clienteAvulso"
                        :position="m.location"
                        :icon="{
                            path: path_closed,
                            scale: 1,
                            //fillColor: `#${m.color}`,
                            fillColor: '#f9e41a',
                            fillOpacity: 1,
                            //strokeColor: `#${m.color}`,
                            strokeColor: '#ab9c05',
                            strokeOpacity: 0.7,
                            strokeWeight: 2,
                            anchor: { x: 10, y: 25 },
                            labelOrigin: { x: 10, y: 10 },
                        }"
                        :visible="visibilityObject[m.idusuario] && showExecuted"
                        @click="openInfoWindow(m)"
                    />

                    <gmap-marker
                        v-else
                        :position="m.location"
                        :icon="{
                            path: path_closed,
                            scale: 1,
                            //fillColor: `#${m.color}`,
                            fillColor: '#419545',
                            fillOpacity: 0.5,
                            //strokeColor: `#${m.color}`,
                            strokeColor: '#419545',
                            strokeOpacity: 0.8,
                            strokeWeight: 1,
                            anchor: { x: 10, y: 25 },
                            labelOrigin: { x: 10, y: 10 },
                        }"
                        :visible="visibilityObject[m.idusuario] && showExecuted"
                        @click="openInfoWindow(m)"
                    />
                </div>
            </gmap-map>
        </div>

        <!-- Botão de retrair -->
        <div
            ref="retractBtn"
            class="retract-button"
            :class="{ 'hide-control-right-btn': !showPanel }"
            v-show="!loadingMap && !$root.gmapsFailure"
        >
            <div class="btn-wrapper" @click="showPanel = !showPanel">
                <b-icon :icon="showPanel ? 'chevron-right' : 'chevron-left'" />
            </div>
        </div>

        <!-- Lista dentro do Mapa -->
        <div
            ref="listaStatus"
            class="control-right normal-inputs"
            :class="{ 'hide-control-right': !showPanel }"
            v-show="!loadingMap && !$root.gmapsFailure"
        >
            <div class="control-container padded is-flex">
                <div class="columns is-multiline">
                    <div class="column is-full pb-0 is-flex is-flex-vbottom">
                        <div class="is-100">
                            <verified-date-picker
                                title="data"
                                v-model="data"
                                :years-range="[-20, 1]"
                                @input="$emit('update:data', $event)"
                                :inForm="true"
                            />
                        </div>
                    </div>
                    <div class="column is-full pt-0 is-flex is-flex-centered">
                        <b-field class="is-100">
                            <b-checkbox-button
                                v-model="showPlanned"
                                class="is-100"
                                type="is-primary"
                                size="is-small"
                                :native-value="true"
                            >
                                <b-icon
                                    v-if="showPlanned"
                                    class="mr-2"
                                    icon="check"
                                    size="is-small"
                                />
                                <span>{{ $t('mostrar-planejado') }}</span>
                            </b-checkbox-button>

                            <b-checkbox-button
                                v-model="showExecuted"
                                class="is-100"
                                type="is-success"
                                size="is-small"
                                :native-value="true"
                            >
                                <b-icon
                                    v-if="showExecuted"
                                    class="mr-2"
                                    icon="check"
                                    size="is-small"
                                />
                                <span>{{ $t('mostrar-executado') }}</span>
                            </b-checkbox-button>
                        </b-field>
                    </div>

                    <div class="column py-0 is-full">
                        <vss-select
                            class="is-default-font-size"
                            v-if="$store.state.user.admin || showVendedores"
                            v-model="vendedoresSelecionados"
                            :options="vendedoresCombo"
                            :height="30"
                            label="nome"
                            @search="loadVendedores"
                            searchable
                            multiple
                            no-clearfix
                            clearable
                        >
                            <template #multiple-selected="{ selected }">
                                {{ $t('vendedores') }} ({{
                                    selected && selected.length > 0 ? selected.length : $t('todos')
                                }})
                            </template>
                        </vss-select>
                    </div>
                    <div class="column py-0">
                        <button class="button btn-search" @click="searchAction">
                            {{ $t('pesquisar') }}
                        </button>
                    </div>
                </div>
                <!-- end .columns -->

                <div class="ctrl-table-wrapper is-grow-1 is-flex is-flex-column">
                    <table class="table is-100 ctrl-table">
                        <thead>
                            <tr>
                                <th style="width: 33px"></th>
                                <th>{{ $t('colaborador') }}</th>
                                <th class="has-text-centered" style="width: 90px">
                                    {{ $t('planejado') }}
                                </th>
                                <th class="has-text-centered" style="width: 90px">
                                    {{ $t('realizado') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="k in Object.keys(usuarios)" :key="k">
                                <td
                                    class="is-clickable"
                                    :class="{ disabled: !visibilityObject[k] }"
                                    @click="toggleVisibility(k)"
                                >
                                    <b-icon
                                        icon="map-marker"
                                        :style="{ color: `#${usuarios[k].pincolor}` }"
                                    />
                                </td>
                                <td>{{ usuarios[k].nome }}</td>
                                <td class="has-text-centered">{{ usuarios[k].planejados }}</td>
                                <td class="has-text-centered">{{ usuarios[k].realizados }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div
                        class="is-grow-1 is-flex is-flex-centered searching-loader"
                        v-if="firstTime"
                    >
                        <svg class="bigicon">
                            <use
                                :xlink:href="require('@/assets/img/icons/magnify.svg') + '#layer'"
                            ></use>
                        </svg>
                        <span class="is-100 has-text-centered">
                            {{ $t('msg-relatorio-rota-first-time-map') }}
                        </span>
                    </div>
                    <div class="is-grow-1 is-flex is-flex-centered" v-else-if="!rotas.length">
                        {{ $t('msg-no-results') }}
                    </div>
                </div>
                <!-- end .ctrl-table-wrapper -->
            </div>
            <!-- end .control-container -->
        </div>
        <!-- end .control-right -->
    </div>
</template>

<script>
import ColaboradorService from '@/services/ColaboradorService';

export default {
    props: {
        data: {
            type: Date,
            default: () => new Date(),
        },
        rotas: {
            type: Array,
            default: () => [],
        },
        /*  Esta variável armazena o ID do pin que está clicado no momento
                usada com o .sync no Rotas.vue pra atualizar automático e lido
                pelo Dados.vue pra marcar o grid. */
        selectedId: {
            type: Number,
            default: () => null,
        },
        firstTime: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            center: { lat: -12.867, lng: -55.625 },
            zoomLevel: 4,
            mapOptions: {
                mapTypeControl: false,
                streetViewControl: false,
                scaleControl: false,
                zoomControl: false,
                fullscreenControl: true,
                clickableIcons: false,
                fullscreenControlOptions: {
                    position: 7, //google.maps.ControlPosition.RIGHT_TOP
                },
            },
            lineOptions: {
                strokeColor: '#4CAF50',
                strokeOpacity: 0.5,
                icons: [
                    {
                        icon: { path: 1 /*google.maps.SymbolPath.FORWARD_OPEN_ARROW*/ },
                        offset: '40%',
                        repeat: '50px',
                    },
                ],
            },
            infoWindow: {
                position: { lat: 0, lng: 0 },
                open: false,
                item: {},
                options: {
                    pixelOffset: { width: 0, height: -30 },
                },
            },
            showPanel: true,
            loadingMap: true,
            showNoVisit: true,
            path:
                'M10.0812 0.00417221V0C10.0537 0 10.0269 0.00166887 10 0.00166887C9.97313 0.00166887 9.94626 0 9.91877 0V0.00417221C4.42628 0.0930404 0 4.64555 0 10.2528C0 17.8089 8.72292 24.9809 10 26C11.2773 24.9811 20 17.8087 20 10.2528C20 4.64555 15.5739 0.0930404 10.0812 0.00417221ZM10.0812 14.663C7.20729 14.663 4.87795 12.2945 4.87795 9.37205C4.87795 6.44879 7.20729 4.0798 10.0812 4.0798C12.9552 4.0798 15.2847 6.44879 15.2847 9.37205C15.2847 12.2945 12.9552 14.663 10.0812 14.663Z',
            path_closed:
                'M10.081.004C4.426.093 0 4.646 0 10.253 0 17.809 8.723 24.981 10 26 11.277 24.981 20 17.809 20 10.253 20 4.646 15.574.093 10.081.004Z',
            visibilityObject: {
                /*  Esse objeto terá uma chave para cada usuário
                        e seu valor será true ou false.
                        
                        É feito com objetos e par chave-valor ao invés de array para
                        facilitar o acesso ao invés de ter que usar o Array.find
                        
                        Ele é preenchido no computed de usuarios. */
            },
            showPlanned: true,
            showExecuted: false,
            showVendedores: false,
            vendedoresCombo: [],
            vendedoresSelecionados: [],
            vendedoresLoading: false,
        };
    },
    computed: {
        usuarios() {
            let users = {};

            this.rotas.forEach((r) => {
                let key = r.usuario.idusuario;

                if (!users[key]) {
                    users[key] = r.usuario;
                    users[key].planejados = 0;
                    users[key].realizados = 0;
                }

                if (!r.clienteAvulso) {
                    users[key].planejados++;

                    let atends = r.atendimentos.length;
                    let nvenda = r.naovendas.length;
                    let pedido = r.pedidos.length;
                    let tpreco = r.tomadaspreco.length;

                    if (atends || nvenda || pedido || tpreco) {
                        users[key].realizados++;
                    }
                }

                if (!this.visibilityObject.hasOwnProperty(key)) {
                    this.$set(this.visibilityObject, key, true);
                }
            });

            return users;
        },
        markers() {
            let markers = [];

            this.rotas
                .filter((e) => !e.clienteAvulso)
                .forEach((r) => {
                    if (r.cliente.latitude && r.cliente.longitude) {
                        markers.push({
                            id: r.idrotavisitahistorico,
                            idusuario: r.usuario.idusuario,
                            idcliente: r.cliente.idcliente,
                            color: r.usuario.pincolor,
                            nome: r.cliente.nome,
                            location: {
                                lat: r.cliente.latitude,
                                lng: r.cliente.longitude,
                            },
                        });
                    }
                });

            return markers;
        },
        markersExecutado() {
            let markers = [];

            this.rotas
                .filter(
                    (e) =>
                        e.pedidos.length ||
                        e.naovendas.length ||
                        e.tomadaspreco.length ||
                        e.atendimentos.length ||
                        e.clienteAvulso
                )
                .forEach((r) => {
                    let loc = this.getLocalizacao(r);

                    /*  A função retorna de quem foi pego a localização.
                            Se foi do cliente, vai cair no mesmo pin do mapa e pode significar duas coisas:
                                - Não foi utilizado checkin
                                - O checkin não é obrigatório no cliente
                            Então esse pin não entra no mapa.
                            Mas no polylineExecutado mantém pq a ordem pode ser diferente. */

                    /* #68452 - Modificado para mostrar os pins mesmo que ele esteja no mesmo lugar que um pin do planejado.
                                Isso para que mostre os pins quando apenas a opção MOSTRAR EXECUTADO estiver ativa.
                        */
                    // if (loc && loc.origin != 'CLIENTE') {
                    if (loc) {
                        markers.push({
                            id: r.idrotavisitahistorico,
                            idusuario: r.usuario.idusuario,
                            idcliente: r.cliente.idcliente,
                            clienteAvulso: r.clienteAvulso,
                            color: r.usuario.pincolor,
                            nome: r.cliente.nome,
                            location: {
                                lat: loc.lat,
                                lng: loc.lng,
                            },
                        });
                    }
                });

            return markers;
        },
        polylines() {
            let lines = {};

            this.rotas.forEach((r) => {
                if (r.cliente.latitude && r.cliente.longitude && !r.clienteAvulso) {
                    let key = `${r.usuario.idusuario}-${r.rotaVisita.idrotavisita}`;

                    let loc = {
                        idcliente: r.cliente.idcliente,
                        lat: r.cliente.latitude,
                        lng: r.cliente.longitude,
                    };

                    if (lines[key]) {
                        lines[key].line.push(loc);
                    } else {
                        lines[key] = {
                            idusuario: r.usuario.idusuario,
                            color: r.usuario.pincolor,
                            nome: r.usuario.nome,
                            line: [loc],
                        };
                    }
                }
            });

            return lines;
        },
        polylineExecutado() {
            let exec = {};

            let atendidos = this.rotas.filter(
                (e) =>
                    e.pedidos.length ||
                    e.naovendas.length ||
                    e.tomadaspreco.length ||
                    e.atendimentos.length
            );

            atendidos.forEach((r) => {
                let loc = this.getLocalizacao(r);

                if (loc) {
                    /* Chave do objeto, usando id usuário e idrotavisita */
                    let key = `${r.usuario.idusuario}-${r.rotaVisita.idrotavisita}-exec`;

                    /* Pegar todos os horários e verificar qual o menor */
                    let times = r.checks
                        .map((e) => new Date(e.checkindatahora))
                        .concat(r.pedidos.map((e) => new Date(e.datahora)))
                        .concat(r.naovendas.map((e) => new Date(e.datahora)))
                        .concat(r.tomadaspreco.map((e) => new Date(e.datahora)))
                        .concat(r.atendimentos.map((e) => new Date(e.datahora)));

                    let earliest = times.length ? times.sort()[0] : null;

                    let line_item = {
                        datahora: earliest,
                        idcliente: r.cliente.idcliente,
                        lat: loc.lat,
                        lng: loc.lng,
                    };

                    /* Se já existe essa chave no objeto, somente adiciona o novo elemento */
                    if (exec[key]) {
                        exec[key].line.push(line_item);

                        /* Do contrário, cria o objeto */
                    } else {
                        exec[key] = {
                            idusuario: r.usuario.idusuario,
                            color: r.usuario.pincolor,
                            nome: r.usuario.nome,
                            line: [line_item],
                        };
                    }
                }
            });

            Object.keys(exec).forEach((k) => {
                exec[k].line.sort((a, b) => a.datahora - b.datahora);
            });

            return exec;
        },
    },
    created() {
        if (!this.$store.state.user.admin) {
            this.$store.commit('addLoader');

            this.colaboradorService
                .findListAssociated('')
                .then((r) => {
                    if (r.content && r.content.length > 1) {
                        this.showVendedores = true;
                        this.vendedoresCombo = r.content;
                    } else {
                        this.showVendedores = false;
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar os vendedores.', e);
                    this.showVendedores = false;
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                });
        }
    },
    mounted() {
        this.$refs.mapRef.$mapPromise.then((map) => {
            setTimeout(() => {
                // Controles laterais
                map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$refs.retractBtn);
                map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(this.$refs.listaStatus);
            }, 200);

            this.loadingMap = false;
        });
    },
    methods: {
        searchAction() {
            if (this.infoWindow.open) {
                this.closeInfoWindow();
            }

            this.$emit(
                'pesquisar',
                this.vendedoresSelecionados.map((e) => e.idusuario)
            );
        },
        loadVendedores(q) {
            this.vendedoresLoading = true;

            this.colaboradorService
                .findListAssociated(q)
                .then((r) => {
                    this.vendedoresCombo = r.content;
                })
                .catch((e) => {
                    console.error('Erro ao carregar os vendedores.', e);
                })
                .finally((_) => {
                    this.vendedoresLoading = false;
                });
        },
        centerMap() {
            this.$refs.mapRef.$mapPromise.then((map) => {
                let bounds = new google.maps.LatLngBounds();

                this.markers.forEach((m) => {
                    bounds.extend(m.location);
                });

                map.fitBounds(bounds);
            });
        },
        getLocalizacao(rota) {
            /*  Método para pegar uma localização do cliente na rota
                    Seja do cliente, do check-in ou do pedido, etc. */

            /* Se não houver, tentar obter algum dos checkins */
            let loc_checks = rota.checks.filter((e) => e.latitudecheckin && e.longitudecheckin);

            if (loc_checks.length > 0) {
                return {
                    lat: loc_checks[0].latitudecheckin,
                    lng: loc_checks[0].longitudecheckin,
                    origin: 'CHECK',
                };
            }

            /* Primeiro verifica se o cliente tem localização cadastrada */
            if (rota.cliente.latitude && rota.cliente.longitude) {
                return {
                    lat: rota.cliente.latitude,
                    lng: rota.cliente.longitude,
                    origin: 'CLIENTE',
                };
            }

            /*  Porém o cliente pode não trabalhar com checkin. Então começa a verificar das
                    ações que ele fez. Não venda e pedido salvam localização. */
            let loc_nvenda = rota.naovendas.filter((e) => e.latitude && e.longitude);

            if (loc_nvenda.length > 0) {
                return {
                    lat: loc_nvenda[0].latitudecheckin,
                    lng: loc_nvenda[0].longitudecheckin,
                    origin: 'NAOVENDA',
                };
            }

            let loc_pedido = rota.pedidos.filter((e) => e.latitude && e.longitude);

            if (loc_pedido.length > 0) {
                return {
                    lat: loc_pedido[0].latitudecheckin,
                    lng: loc_pedido[0].longitudecheckin,
                    origin: 'PEDIDO',
                };
            }

            /* Se não achou nada, retorna null */
            return null;
        },
        openInfoWindow(marker) {
            let id_historico = marker.id;

            if (
                this.infoWindow.open &&
                this.infoWindow.item &&
                id_historico == this.infoWindow.item.idrotavisitahistorico
            ) {
                this.closeInfoWindow();
            } else {
                this.infoWindow.position = marker.location;
                this.infoWindow.item = this.rotas.find(
                    (e) => e.idrotavisitahistorico == id_historico
                );
                this.infoWindow.open = true;

                this.$emit('update:selectedId', id_historico);
            }
        },
        closeInfoWindow() {
            this.$emit('update:selectedId', null);
            this.infoWindow.open = false;
        },
        toggleVisibility(key) {
            this.visibilityObject[key] = !this.visibilityObject[key];

            /*  Se o balão estiver aberto, for do usuário que está clicando no ícone e
                    estiver deixando invisível, fecha o balão */
            if (
                this.infoWindow.open &&
                this.infoWindow.item &&
                this.infoWindow.item.usuario.id == key &&
                !this.visibilityObject[key]
            ) {
                this.closeInfoWindow();
            }
        },
        getTipoFrequencia(valor) {
            switch (Number(valor)) {
                case 1:
                    return 'qtde-dias';
                case 2:
                    return 'dias-semana';
                default:
                    console.warn('Tipo de frequência desconhecido.', valor);
                    return 'desconhecido';
            }
        },
        getDias(dias) {
            /*  Por que retorno as chaves do dicionário e não as chaves já traduzidas pelo tradutor?
                Pois não vai mudar a string quando trocar de língua.
                Para garantir que, quando ocorrer a troca de língua, as strings mudem, a chamada do tradutor
                tem que estar no <template>, não no <script>.
            */
            if (typeof dias === 'string') {
                return dias.split(',').map((d) => {
                    switch (d) {
                        case '1':
                            return 'domingo';
                        case '2':
                            return 'segunda';
                        case '3':
                            return 'terca';
                        case '4':
                            return 'quarta';
                        case '5':
                            return 'quinta';
                        case '6':
                            return 'sexta';
                        case '7':
                            return 'sabado';
                        default:
                            return 'desconhecido';
                    }
                });
            } else {
                return [];
            }
        },
        getPermiteAvulso(valor) {
            switch (Number(valor)) {
                case 0:
                    return 'nao';
                case 1:
                    return 'sim';
                case 2:
                    return 'com-contrassenha';
                default:
                    console.warn('"Permite Avulso" desconhecido.', valor);
                    return 'desconhecido';
            }
        },
        getPeriodo(periodo) {
            switch (Number(periodo)) {
                case 0:
                    return 'manha';
                case 1:
                    return 'tarde';
                case 2:
                    return 'noite';
                default:
                    return 'nao-informado';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.control-right {
    min-height: 400px;
}

.mapa-wrapper {
    height: 100%;
    min-height: 500px;

    &.disabled {
        opacity: 0.5;
    }

    .gmaps {
        height: 100%;
    }
}

.control-container {
    button.small-btn {
        height: 36px;
        padding: 0 1rem;
    }

    .ctrl-table {
        margin-bottom: 0;
    }
}

hr + .info-detail {
    margin-top: 0 !important;
}

.info-detail:not(:first-child) {
    margin-top: 0.5rem;
}

.info-detail {
    span.description {
        max-width: 70%;
    }
}

table.det-tbl {
    width: 100%;

    td {
        border: 0;
    }
}
</style>
